import React from 'react';
import { KeyboardArrowDown } from '@mui/icons-material';
import {
  InputBase,
  Select as MuiSelect,
  SelectProps,
  MenuProps as MUIMenuProps,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { FONT_GSS_FUTURA_BOOK } from '@monorepo/shared/src/themes/defaultTheme';
import { remCalc } from '@monorepo/shared/src/util/style-util';

type Props = SelectProps & {
  noBorder?: boolean;
};

const Select: React.FC<Props> = ({ children, label, id, MenuProps, noBorder, ...rest }) => {
  const classes = useStyles({ noBorder });

  const customMenuProps = {
    PaperProps: {
      style: {
        boxShadow: 'none',
        border: `1px solid black`,
        borderRadius: 0,
      },
    },
    getContentAnchorEl: null,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'left',
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'left',
    },
    ...MenuProps,
  } as MUIMenuProps;

  return (
    <MuiSelect
      labelId={`${id}-label`}
      id={id}
      input={
        <InputBase
          classes={{
            root: classes.root,
            input: classes.input,
          }}
        />
      }
      IconComponent={KeyboardArrowDown}
      classes={{
        icon: classes.icon,
      }}
      displayEmpty={true}
      MenuProps={customMenuProps}
      autoWidth={true}
      {...rest}
    >
      {children}
    </MuiSelect>
  );
};

const useStyles = makeStyles((theme: any) => ({
  root: {
    display: 'flex',
    fontFamily: FONT_GSS_FUTURA_BOOK,
    fontSize: remCalc(14),
  },
  input: {
    lineHeight: remCalc(32),
    height: remCalc(44),
    border: ({ noBorder }: Props) => (noBorder ? 'unset' : `2px solid ${theme.palette.black.main}`),
    borderRadius: '8px',
    marginTop: '2px',
    paddingLeft: remCalc(10),
    paddingRight: remCalc(0),
    userSelect: 'none',
    boxSizing: 'border-box',
    '&:focus-within': {
      outline: '#248AFF auto 1px',
      borderRadius: '8px',
      backgroundColor: '#FFFFFF',
    },
  },
  icon: {
    right: ({ noBorder }: Props) => (noBorder ? '0px' : '5px'),
    color: '#202020',
    transition: 'transform 0.1s ease-in-out',
  },
}));

export default Select;
